/**
 * Marca de sesión del modal "Último Registro de Ventas".
 *
 * El modal se muestra una sola vez tras iniciar sesión. La marca vive en
 * sessionStorage, por lo que sobrevive a recargas y navegación dentro de la
 * misma pestaña, pero debe limpiarse en cada login y logout: de lo contrario
 * quien cierra sesión y vuelve a entrar en la misma pestaña nunca vuelve a ver
 * el aviso de credenciales caídas.
 */
const SALES_STATUS_SHOWN_KEY = 'salesStatusShown'

export function wasSalesStatusShown () {
  return !!sessionStorage.getItem(SALES_STATUS_SHOWN_KEY)
}

export function markSalesStatusShown () {
  sessionStorage.setItem(SALES_STATUS_SHOWN_KEY, '1')
}

export function clearSalesStatusShown () {
  sessionStorage.removeItem(SALES_STATUS_SHOWN_KEY)
}



// WEBPACK FOOTER //
// ./src/app/shared/salesStatusSession.js